function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M38 1h24c20.987 0 38 17.013 38 38v24.877c0 20.987-17.013 38-38 38H0V39C0 18.013 17.013 1 38 1z",
  fill: "#EBB211",
  fillRule: "evenodd"
});

function SvgGroup2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 102"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iI0VCQjIxMSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik04NTIgMTEwMGgyNGMyMC45ODcgMCAzOCAxNy4wMTMgMzggMzh2MjQuODc3YzAgMjAuOTg3LTE3LjAxMyAzOC0zOCAzOGgtNjJWMTEzOGMwLTIwLjk4NyAxNy4wMTMtMzggMzgtMzh6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODE0IC0xMDk5KSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgGroup2 as ReactComponent };